import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Card, CardHeader, CardBody, Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import async from 'async';

import TextTruncate from 'react-text-truncate';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, numberFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';

import EstablishmentsEditor from './Editor';

import Lang from '../../languages';
import Config from '../../config';

import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './List.css';

const { ExportCSVButton } = CSVExport;

class EstablishmentsList extends Component {
 constructor(props) {
  super(props);

  this.state = {
   page: 1,
   data: [],
   totalSize: 0,
   sizePerPage: 10,
   sortField: 'name',
   editorWindow: false,
   confirmValue: '',
   selected: [],
   selectedEstablishment: null
  };

  this.filters = { 'text': {}, 'number': {}, 'date': {} }

  if (window.innerWidth <= 768) {
   this.columns = [
    { dataField: 'name', text: Lang[this.props.session.language].Establishments.columns.name, formatter: (cellContent, row) => { return <Link to={this.props.location.pathname + '/' + row.ID}>{cellContent}</Link> }, sort: true }
   ]
  } else {
   this.columns = [
    { dataField: 'name', text: Lang[this.props.session.language].Establishments.columns.name, filter: textFilter({ getFilter: (filter) => { this.filters['text'].name = filter } }), formatter: (cellContent, row) => { return <Link to={this.props.location.pathname + '/' + row.ID}>{cellContent}</Link> }, sort: true },
    { dataField: 'description', text: Lang[this.props.session.language].Establishments.columns.description, filter: textFilter({ getFilter: (filter) => { this.filters['text'].description = filter } }), formatter: (cellContent, row) => { return <TextTruncate line={1} element="span" truncateText="…" text={cellContent.replace(/<[^>]+>/g, '').replace(/\&nbsp;/g, '')} />  }, sort: false },
    { dataField: 'full_address', text: Lang[this.props.session.language].Establishments.columns.full_address, filter: textFilter({ getFilter: (filter) => { this.filters['text'].full_address = filter } }), sort: false },
    {
     dataField: 'ID', text: 'ID', headerStyle: () => { return { width: '108px' } }, headerFormatter: () => (
      <Button className="float-right" title="Restablecer filtros" onClick={this.resetFilters}><i className="fa fa-filter"></i>&nbsp;{Lang[this.props.session.language].tableReset}</Button>
     ), formatter: (cellContent, row) => {
      return (
       <div className="checkbox disabled">
        {
         this.props.session.permissions.controllers.establishments.find(el => el == 'update') ?
          <Button color="primary" onClick={() => this.openEditor(row.ID)}><i className="fa fa-edit"></i></Button>
          : this.props.session.user.ID == row.owner ?
           <Button color="primary" onClick={() => this.openEditor(row.ID)}><i className="fa fa-edit"></i></Button>
           : null
        }
        {' '}
        {
         this.props.session.permissions.controllers.establishments.find(el => el == 'delete') ?
          <Button color="danger" onClick={() => this.doDelete(row.ID)}><i className="fa fa-trash"></i></Button>
          : this.props.session.user.ID == row.owner ?
           <Button color="danger" onClick={() => this.doDelete(row.ID)}><i className="fa fa-trash"></i></Button>
           : null
        }
       </div>
      )
     }
    }
   ]
  }

  this.doDelete = this.doDelete.bind(this);

  this.openEditor = this.openEditor.bind(this);
  this.closeEditor = this.closeEditor.bind(this);

  this.resetFilters = this.resetFilters.bind(this);
  this.handleOnSelect = this.handleOnSelect.bind(this);
  this.handleOnSelectAll = this.handleOnSelectAll.bind(this);
  this.handleTableChange = this.handleTableChange.bind(this);
  this.handleClickDelete = this.handleClickDelete.bind(this);
 }

 resetFilters() {
  Object.keys(this.filters).forEach(type => {
   Object.keys(this.filters[type]).forEach(key => {
    var filterFunction = this.filters[type][key];
    switch (type) {
     case 'text': filterFunction(''); break;
     case 'date': filterFunction({ date: new Date(), comparator: '' }); break;
     case 'number': filterFunction({ number: '', comparator: '' }); break;
    }
   });
  })
 }

 handleOnSelect(row, isSelect, rowIndex, e) {
  if (isSelect) {
   this.setState({ selected: [...this.state.selected, row.ID] });
  } else {
   this.setState({ selected: this.state.selected.filter(x => x !== row.ID) });
  }
 }

 handleOnSelectAll(isSelect, rows, e) {
  const IDs = rows.map(r => r.ID);
  if (isSelect) {
   this.setState({ selected: [...this.state.selected, ...IDs] });
  } else {
   this.setState({ selected: this.state.selected.filter((e) => { return IDs.indexOf(e) < 0 }) });
  }
 }

 handleTableChange(type, { page, sizePerPage, filters, sortField, sortOrder }) {
  this.props.reqAPI(Config.apiURI + '/api/establishments', 'POST', { page, sizePerPage, filters, sortField, sortOrder, language: this.props.session.language }).then(data => {
   this.setState(() => ({ page, data: data.items, totalSize: data.total, sizePerPage, filters, sortField, sortOrder }));
  });
 }

 handleClickDelete(IDs, onClose) {
  if (this.state.confirmValue == Lang[this.props.session.language].DeleteConfirmValue) {
   var jobs = [];
   var self = this;
   IDs.map((ID) => {
    jobs.push(function (callback) {
     self.props.reqAPI(Config.apiURI + '/api/establishments/' + ID, 'DELETE').then(result => {
      callback(false, result);
     });
    })
   })

   async.parallel(jobs, function (err, results) {
    onClose();
    self.setState({ confirmValue: '' }, () => {
     self.handleTableChange('reload', {
      page: self.state.page,
      sizePerPage: self.state.sizePerPage,
      filters: self.state.filters,
      sortField: self.state.sortField,
      sortOrder: self.state.sortOrder
     });
    })

    for (var key = 0; key < results.length; key++) {
     if (results[key].success) toast.success(Lang[self.props.session.language].Establishments.hasBeenDeleted(results[key].name));
     else toast.error(Lang[self.props.session.language].Establishments.hasNotBeenDeleted(results[key].name), { autoClose: 10000 });
    }
   });
  }
 }


 doDelete(ID, error = false) {
  var IDs = ID === null ? this.state.selected : typeof (ID) === 'object' ? ID : [ID];
  confirmAlert({
   customUI: ({ onClose }) => {
    return (
     <Card className='confirm-delete alert-danger'>
      <CardBody>
       <h2>{Lang[this.props.session.language].DeleteConfirmTitle}</h2>
       <p>{Lang[this.props.session.language].Establishments.isGoingToDelete(IDs)}</p>
       <p><strong>{Lang[this.props.session.language].DeleteConfirmMessage}</strong></p>
       <InputGroup>
        <Input type="text" placeholder={Lang[this.props.session.language].DeleteConfirmPlaceholder}
         onKeyPress={(event) => { if (event.key === 'Enter') this.handleClickDelete(IDs, onClose); }}
         onChange={(e) => { this.setState({ confirmValue: e.target.value }); }}
         className={error ? 'border border-danger' : ''}
        />
        <InputGroupAddon addonType="append">
         <Button color="danger" onClick={() => { this.handleClickDelete(IDs, onClose); }}>{Lang[this.props.session.language].DeleteConfirmYES}</Button>
         <Button color="primary" onClick={onClose}>{Lang[this.props.session.language].DeleteConfirmNO}</Button>
        </InputGroupAddon>
       </InputGroup>
      </CardBody>
     </Card>
    );
   }
  });
 }


 openEditor(ID) {
  if (ID === null) {
   this.setState({ selectedEstablishment: null }, function () {
    this.setState({ editorWindow: true });
   });
  } else {
   this.props.reqAPI(Config.apiURI + '/api/establishments/' + ID + '?full').then(establishment => {
    this.setState({ selectedEstablishment: establishment }, function () {
     this.setState({ editorWindow: true });
    });
   })
  }
 }

 closeEditor(state) {
  if (state) toast.success('Los cambios han sido guardados');
  this.setState({ selectedEstablishment: null, editorWindow: false });
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }

 componentDidMount() {
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }


 render() {
  return (
   <Card>
    <ToolkitProvider keyField="ID" data={this.state.data} columns={this.columns} exportCSV>
     {
      props => (
       <CardBody>
        <ExportCSVButton className="btn btn-primary" {...props.csvProps}>{Lang[this.props.session.language].ExportCSV}</ExportCSVButton>
        {' '}
        {this.props.session.permissions.controllers.establishments.find(el => el == 'create') ? <Button color="success" onClick={() => this.openEditor(null)}><i className="fa fa-plus"></i> {Lang[this.props.session.language].Establishments.buttons.add}</Button> : null}
        {' '}
        {this.state.selected.length > 0 ? <Button color="danger" onClick={() => this.doDelete(null)}><i className="fa fa-minus"></i> {Lang[this.props.session.language].Establishments.buttons.delSelected}</Button> : ''}

        <BootstrapTable
         remote
         striped
         condensed
         bootstrap4
         bordered={false}
         keyField="ID"
         data={this.state.data}
         columns={this.columns}
         selectRow={{
          mode: 'checkbox',
          onSelect: this.handleOnSelect,
          onSelectAll: this.handleOnSelectAll
         }}
         defaultSorted={[{
          dataField: 'name',
          order: 'asc'
         }]}
         filter={filterFactory()}
         pagination={
          paginationFactory({
           page: this.state.page,
           sizePerPage: this.state.sizePerPage,
           sizePerPageList: [
            { text: '5', value: 5 },
            { text: '10', value: 10 },
            { text: '25', value: 25 },
            { text: '50', value: 50 },
            { text: '100', value: 100 }
           ],
           showTotal: true,
           totalSize: this.state.totalSize,
           firstPageText: Lang[this.props.session.language].pagination.firstPageText,
           prePageText: Lang[this.props.session.language].pagination.prePageText,
           nextPageText: Lang[this.props.session.language].pagination.nextPageText,
           lastPageText: Lang[this.props.session.language].pagination.lastPageText,
           firstPageTitle: Lang[this.props.session.language].pagination.firstPageTitle,
           nextPageTitle: Lang[this.props.session.language].pagination.nextPageTitle,
           prePageTitle: Lang[this.props.session.language].pagination.prePageTitle,
           lastPageTitle: Lang[this.props.session.language].pagination.lastPageTitle,
           paginationTotalRenderer: (from, to, size) => (
            <span className="react-bootstrap-table-pagination-total" dangerouslySetInnerHTML={{ __html: '&nbsp;' + Lang[this.props.session.language].paginationFooter(from, to, size) + ' ' + Lang[this.props.session.language].Establishments.name }} />
           )
          })
         }
         onTableChange={this.handleTableChange}
         noDataIndication={Lang[this.props.session.language].tableEmpty}
         {...props.baseProps} />
       </CardBody>
      )
     }
    </ToolkitProvider>

    <EstablishmentsEditor {...this.props} open={this.state.editorWindow} establishment={this.state.selectedEstablishment} handleClose={this.closeEditor} onComplete={this.closeEditor} />
   </Card>
  )
 }
}

export default EstablishmentsList;



// WEBPACK FOOTER //
// ./websources/views/Establishments/List.js